// Airtable Storage Adapter
export { 
  AirtableStorageAdapter, 
  createAirtableAdapter,
  type AirtableConfig
} from './airtable-adapter';

// Re-export storage types
export type {
  StorageAdapter,
  StorageRecord,
  StorageFilter
} from '../types';